// extracted by mini-css-extract-plugin
export default {"empty-container":"gYprKjK66gEWNjGZ0Han","emptyContainer":"gYprKjK66gEWNjGZ0Han","text-group":"pNf6_gdZrN97jquMferA","textGroup":"pNf6_gdZrN97jquMferA"};